import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InvitePageComponent } from './components/invite-page/invite-page.component';
import { LoginBasePageComponent } from './components/login/login-base-page/login-base-page.component';
import { LoginDialogComponent } from './components/login/login-dialog/login-dialog.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { DownloadAreaTableComponent } from './pages/download-area-table/download-area-table.component';
import { DownloadTableComponent } from './pages/download-table/download-table.component';
import { ServiceUnavailableComponent } from './pages/error-pages/503/service-unavailable/service-unavailable.component';
import { PortalBaseComponent } from './pages/portal-base/portal-base.component';
import { ProjectDetailsComponent } from './pages/projects/projectDetails/projectDetails.component';
import { ProjectListComponent } from './pages/projects/projectList/projectList.component';
import { ProjectsComponent } from './pages/projects/projects.component';
import { ReportTableComponent } from './pages/report-table/report-table.component';
import { AOISReportComponent } from './pages/report/AOISReport/AOISReport.component';
import { AreaReportComponent } from './pages/report/areaReport/areaReport.component';
import { ReportAreaDetailsComponent } from './pages/report/report-area-details/report-area-details-modal.component';
import { ReportComponent } from './pages/report/report.component';
import { RiskMapComponent } from './pages/risk-map/risk-map.component';
import { AccountComponent } from './pages/settings/account/account.component';
import { ApiKeysComponent } from './pages/settings/api-keys/api-keys.component';
import { ChangePasswordComponent } from './pages/settings/change-password/change-password.component';
import { PlanUsageComponent } from './pages/settings/plan_usage/plan_usage.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { TeamComponent } from './pages/settings/team/team.component';
import { authGuard } from './services/guards/auth.guard';
import { guestGuard } from './services/guards/guest.guard';

const routes: Routes = [
  {
    path: '',
    component: PortalBaseComponent,
    children: [
      {
        path: '',
        redirectTo: 'projects',
        pathMatch: 'full'
      },
      {
        path: 'projects',
        component: ProjectsComponent,
        canActivate: [authGuard],
        children: [
          {
            path: '',
            component: ProjectListComponent
          },
          {
            path: 'details',
            redirectTo: '',
            pathMatch: 'full'
          },
          {
            path: 'details/:detailsId',
            component: ProjectDetailsComponent
          }
        ]
      },
      {
        path: 'downloads',
        component: DownloadTableComponent,
        canActivate: [authGuard]
      },
      {
        path: 'downloads/:id',
        component: DownloadAreaTableComponent,
        canActivate: [authGuard]
      },
      {
        path: 'report-table',
        component: ReportTableComponent,
        canActivate: [authGuard]
      },
      {
        path: 'report/:id',
        component: ReportComponent,
        canActivate: [authGuard],
        children: [
          {
            path: '',
            component: AOISReportComponent
          },
          {
            path: 'collection/:collectionId',
            component: AreaReportComponent
          },
          {
            path: 'collection/:collectionId/details/:detailsId',
            component: ReportAreaDetailsComponent
          }
        ]
      },
      {
        path: 'risk-map',
        canActivate: [authGuard],
        children: [
          // {
          //   path: '',
          //   component: RiskMapComponent
          // },
          {
            path: '**',
            component: RiskMapComponent
          }
        ]
      },
      {
        path: 'settings',
        component: SettingsComponent,
        canActivate: [authGuard],
        children: [
          {
            path: '',
            redirectTo: 'account'
          },
          {
            path: 'account',
            component: AccountComponent
          },
          {
            path: 'usage',
            component: PlanUsageComponent
          },
          {
            path: 'changePassword',
            component: ChangePasswordComponent
          },
          {
            path: 'team',
            component: TeamComponent
          },
          {
            path: 'apiKeys',
            component: ApiKeysComponent
          }
        ]
      },
      {
        path: '503',
        component: ServiceUnavailableComponent,
        canActivate: [authGuard],
        children: []
      }
    ]
  },

  {
    path: 'login',
    component: LoginBasePageComponent,
    canActivate: [guestGuard],
    children: [
      {
        path: '',
        component: LoginDialogComponent
      }
    ]
  },
  {
    path: 'invites',
    component: LoginBasePageComponent,
    canActivate: [guestGuard],
    children: [
      {
        path: 'accept/:invite-hash',
        component: InvitePageComponent
      }
    ]
  },
  {
    path: 'password/reset',
    component: LoginBasePageComponent,
    canActivate: [guestGuard],
    children: [
      {
        path: 'confirm',
        component: ResetPasswordComponent
      }
    ]
  },

  {
    path: '503',
    component: ServiceUnavailableComponent,
    canActivate: [guestGuard],
    children: []
  },
  {
    path: '**',
    canActivate: [authGuard],
    redirectTo: 'risk-map',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      bindToComponentInputs: true,
      paramsInheritanceStrategy: 'always'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
